module.exports = __webpack_public_path__ + "img/bird-fly-3.6b339100.png";